import { MessageService, type Chat, type Message } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessageMarkRead = () => {
  const { send: markMessageRead } = useFetchComposable(
    ({ chatId, messageId }: { chatId: Chat['id']; messageId: Message['id'] }) =>
      MessageService.markMessageRead({ path: { id: chatId, messageId } }),
  );

  return { markMessageRead };
};

export { useMessageMarkRead };
